<template>
  <div>
    <div v-if="ticket.id" class="card card-custom">
      <!--begin::Header-->
      <div class="card-header align-items-center px-4 py-3">
        <div class="card-title">
          <h3 class="card-label">
            {{ ticket.title }}
          </h3>
        </div>
      </div>
      <!--end::Header-->
      <!--begin::Body-->
      <div class="card-body">
        <div v-if="loaded && ticket && ticket.messages.length === 0">
          <div class="alert alert-primary" role="alert">پیغامی یافت نشد .</div>
        </div>
        <div class="messages">
          <template v-for="item in ticket.messages">
            <div :key="item.id">
              <!--begin::Message Out-->
              <div v-if="item.user_id === currentUserPersonalInfo.id">
                <div class="d-flex flex-column mb-5 align-items-start">
                  <div class="d-flex align-items-center">
                    <div class="symbol symbol-circle symbol-35 mr-3">
                      <img alt="you" src="/media/users/blank.png" />
                    </div>
                    <div>
                      <span class="text-dark-75 font-weight-bold font-size-h6">
                        شما
                      </span>
                      <span
                        class="text-muted font-size-sm font-family-base px-3"
                        dir="ltr"
                      >
                        {{ formatDate(item.created_at) }}
                      </span>
                    </div>
                  </div>
                  <div
                    class="mt-2 rounded p-5 bg-light-primary text-dark-50 font-weight-bold font-size-lg text-right max-w-400px"
                  >
                    {{ item.content }}
                    <div v-for="file in item.files" :key="file">
                      <span
                        class="svg-icon svg-icon-5x svg-icon-primary cursor-pointer"
                        @click="download(file)"
                      >
                        <inline-svg
                          src="/media/svg/icons/Files/DownloadedFile.svg"
                        ></inline-svg>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!--end::Message Out-->
              <!--begin::Message In-->
              <div v-else>
                <div class="d-flex flex-column mb-5 align-items-end">
                  <div class="d-flex align-items-center">
                    <div>
                      <span
                        class="text-muted font-size-sm font-family-base px-3"
                        dir="ltr"
                      >
                        {{ formatDate(item.created_at) }}
                      </span>
                      <span
                        v-if="userShowRoute === ''"
                        class="text-dark-75 font-weight-bold font-size-h6"
                      >
                        {{ gFullName(item.user) }}
                      </span>
                      <router-link
                        v-if="userShowRoute !== ''"
                        :to="{
                          name: userShowRoute,
                          params: { id: item.user_id }
                        }"
                        class="text-dark-75 text-hover-primary font-weight-bold font-size-h6"
                      >
                        {{ gFullName(item.user) }}
                      </router-link>
                    </div>
                    <div class="symbol symbol-circle symbol-35 ml-3">
                      <img
                        :alt="item.user.last_name"
                        src="/media/users/blank.png"
                      />
                    </div>
                  </div>
                  <div
                    class="mt-2 rounded p-5 bg-light-success text-dark-50 font-weight-bold font-size-lg text-left max-w-400px"
                  >
                    {{ item.content }}
                    <div v-for="file in item.files" :key="file">
                      <span
                        class="svg-icon svg-icon-5x svg-icon-primary cursor-pointer"
                        @click="download(file)"
                      >
                        <inline-svg
                          src="/media/svg/icons/Files/DownloadedFile.svg"
                        ></inline-svg>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!--end::Message In-->
            </div>
          </template>
        </div>
      </div>
      <!--end::Body-->
      <!--begin::Footer-->
      <div v-if="ticket.status !== 3" class="card-footer align-items-center">
        <textarea
          class="form-control border-0 p-0"
          rows="2"
          placeholder="تایپ کنید"
          v-model="content"
        ></textarea>
        <div class="d-flex align-items-center justify-content-between mt-5">
          <div class="mr-3">
            <label class="btn btn-clean btn-icon btn-md mr-1">
              <i class="flaticon-attachment icon-lg"></i>
              <input
                type="file"
                accept=".png, .jpg, .jpeg, .zip, .rar, .csv, .txt"
                @change="fileChanged"
                ref="file"
                hidden
              />
            </label>
            <span ref="filename"></span>
          </div>
          <div>
            <button
              type="button"
              class="btn btn-primary btn-md text-uppercase font-weight-bold chat-send py-2 px-6"
              @click="sendTicketMessage()"
            >
              ارسال
            </button>
          </div>
        </div>
      </div>
      <div
        v-else-if="isCompany || isAdmin"
        class="card-footer align-items-center"
      >
        برای ارسال پیغام جدید ابتدا تیکت را باز کنید .
      </div>
      <div v-else class="card-footer align-items-center">
        این تیکت بسته شده است.
      </div>
      <!--end::Footer-->
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  ADD_ACTIONS,
  REMOVE_BUTTON_ACTIONS,
  SET_ACTIONS
} from "@/core/services/store/actions.module";
import {
  FETCH_TICKET,
  SET_TICKET,
  STORE_TICKET_MESSAGE,
  GET_TICKET_MESSAGE_FILE_URL,
  UPDATE_TICKET_STATUS
} from "@/core/services/store/tickets.module";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "tickets-show",
  data() {
    return {
      content: "",
      loaded: false,
      checkButtons: true,
      isAdmin: this.$route.name.startsWith("admin"),
      isCompany: this.$route.name.startsWith("company"),
      userShowRoute: ""
    };
  },
  components: {},
  beforeMount() {
    this.$store.commit(SET_TICKET, {});
    this.setActions();
  },
  computed: {
    ...mapGetters(["ticket"])
  },
  mounted() {
    this.getTicket();

    if (this.isAdmin) {
      this.userShowRoute = "admin-users-show";
    } else if (this.isCompany) {
      this.userShowRoute = "company-users-show";
    }
  },

  methods: {
    sendTicketMessage() {
      let id = this.$route.params.id;

      const formData = new FormData();
      formData.append("content", this.content);

      if (this.$refs.file.files && this.$refs.file.files[0]) {
        formData.append("file", this.$refs.file.files[0]);
      }

      this.$store
        .dispatch(STORE_TICKET_MESSAGE, {
          id,
          formData
        })
        .then(() => {
          this.getTicket();
          this.content = "";
          this.$refs.file.value = "";
          this.$refs.filename.innerText = "";
        });
    },
    getTicket() {
      let ticketId = this.$route.params.id;
      this.loaded = false;
      this.$store
        .dispatch(FETCH_TICKET, ticketId)
        .then(() => {
          this.loaded = true;
          this.setBreadcrumbs();
          if (this.checkButtons && (this.isAdmin || this.isCompany)) {
            this.setButtons();
            this.checkButtons = false;
          }
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    setBreadcrumbs() {
      let ticketsRouteName = "tickets-index";
      let items = [];
      items.push({ title: "پشتیبانی", route: { name: ticketsRouteName } });
      items.push({ title: this.ticket.title });
      this.$store.dispatch(SET_BREADCRUMB, items);
    },
    setActions() {
      let ticketsRouteName = "tickets-index";
      this.$store.dispatch(SET_ACTIONS, {
        links: [
          {
            name: "بازگشت",
            to: { name: ticketsRouteName }
          }
        ]
      });
    },
    fileChanged(event) {
      try {
        this.$refs.filename.innerText = event.target.files[0].name;
      } catch (e) {
        this.$refs.filename.innerText = "";
      }
    },
    download(path) {
      this.$store.dispatch(GET_TICKET_MESSAGE_FILE_URL, path).then(url => {
        // this.downloadFile(url, path.replace(/^.*[\\/]/, ""));
        Swal.fire({
          html: `<a class="btn btn-primary btn-lg" href="${url}" target="_blank" download>دانلود</a>`,
          showCloseButton: false,
          showCancelButton: false,
          showConfirmButton: false
        });
      });
    },
    setButtons() {
      let openBtn = {
        name: '<i class="fas fa-envelope-open"></i>باز کردن ',
        event: "start-ticket-event",
        class: "btn-success",
        id: "start-ticket-btn"
      };
      let closeBtn = {
        name: '<i class="fas fa-window-close"></i> بستن',
        event: "stop-ticket-event",
        class: "btn-danger",
        id: "stop-ticket-btn"
      };

      let buttons = [];
      if (this.ticket.status == 3) {
        buttons.push(openBtn);
      } else {
        this.$store.commit(REMOVE_BUTTON_ACTIONS, openBtn);
      }
      if (this.ticket.status == 1 || this.ticket.status == 2) {
        buttons.push(closeBtn);
      } else {
        this.$store.commit(REMOVE_BUTTON_ACTIONS, closeBtn);
      }
      this.$store.dispatch(ADD_ACTIONS, {
        buttons: buttons
      });

      this.eventHub.$on("start-ticket-event", this.openTicket);
      this.eventHub.$on("stop-ticket-event", this.closeTicket);
    },
    openTicket() {
      let id = this.$route.params.id;
      let status = 1;
      Swal.fire({
        title: "",
        text: "آیا از باز کردن تیکت اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#1e1f22",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          let openBtn = document.getElementById("start-ticket-btn");
          this.disableBtn(openBtn);
          this.$store
            .dispatch(UPDATE_TICKET_STATUS, { id, status })
            .then(() => {
              this.getTicket();
              this.checkButtons = true;
              this.enableBtn(openBtn);
              Swal.fire({
                icon: "success",
                title: "تیکت  باز شد",
                showConfirmButton: false,
                timer: 1500
              });
            })
            .catch(() => {
              this.enableBtn(openBtn);
            });
        }
      });
    },
    closeTicket() {
      let id = this.$route.params.id;
      let status = 3;
      Swal.fire({
        title: "",
        text: "آیا از بستن تیکت اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#1e1f22",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          let closeBtn = document.getElementById("stop-ticket-btn");
          this.disableBtn(closeBtn);
          this.$store
            .dispatch(UPDATE_TICKET_STATUS, { id, status })
            .then(() => {
              this.getTicket();
              this.checkButtons = true;
              this.enableBtn(closeBtn);
              Swal.fire({
                icon: "success",
                title: "تیکت  بسته شد",
                showConfirmButton: false,
                timer: 1500
              });
            })
            .catch(() => {
              this.enableBtn(closeBtn);
            });
        }
      });
    }
  }
};
</script>
